module.exports = __webpack_public_path__ + "static/media/clubs-fair.31e55839.jpg";